import styled from 'styled-components';
import TimeField from 'react-simple-timefield';
import colors from 'themes/Main';

const { gray01, gray03, gray05 } = colors;

export const Hour = styled(TimeField)`
  width: ${({ width }) => `${width}%`};
  padding: 0 16px;
  height: 40px;
  color: ${gray01};
  font-size: 14px;
  background-color: transparent;
  border: 1px solid ${gray03};
  border-radius: 5px;

  &:disabled {
    background-color: ${gray05};
    opacity: 0.6;
  }

  &::-webkit-datetime-edit-ampm-field {
    display: none;
  }

  &::-webkit-clear-button {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    margin: 0;
  }

  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    margin: 0;
  }
`;
